import Router from 'vue-router';

import managementRouter from './management';
import formRouter from './form';

import Home from '@/views/Home.vue';
import ErrorPage from '@/views/ErrorPage.vue';
import RouterView from '@/views/common/RouterViewWrapper.vue';

const createRouter = store => {
  const router = new Router({
    routes: [
      {
        path: '/',
        name: 'home',
        component: Home,
      },
      {
        path: '/management',
        component: RouterView,
        children: managementRouter,
      },
      {
        path: '/form',
        component: RouterView,
        children: formRouter,
      },
      {
        path: '*',
        component: ErrorPage,
      },
    ],
    linkActiveClass: 'active',
  });

  router.beforeEach(async (to, from, next) => {
    if (to.meta.noAuth) {
      next();
      return;
    }

    const user = await store.dispatch('user/fetchUserInfo');

    if (to.path === '/') {
      next();
      return;
    }

    if (user.isAuthenticated) {
      const { permissions } = to.meta;
      if (!permissions || permissions.some(permission => user[permission])) {
        next();
        return;
      }
    }

    next('/');
  });

  return router;
};

export default {
  router: null,
  getRouter() {
    return this.router;
  },
  createFor(vueInstance, store) {
    vueInstance.use(Router);
    this.router = createRouter(store);
    return this.getRouter();
  },
};
